let productFormInitialized = false;

function initProductForm(isReinit = false) {
  const forms = document.querySelectorAll(".product-form form");

  if (!forms.length) return;

  forms.forEach((form) => {
    // Skip if already initialized (unless forcing reinit)
    if (form.dataset.formInitialized === "true" && !isReinit) {
      return;
    }

    const dataEl = form.querySelector(".js-product-form-data");
    if (!dataEl) return;

    const variantData = JSON.parse(dataEl.getAttribute("data-variants"));
    const productId = JSON.parse(dataEl.getAttribute("data-product-id"));
    const optionCount = parseInt(dataEl.dataset.optionsSize, 10);
    const initialVariantId = parseInt(dataEl.dataset.currentVariantId, 10);
    const variantOptionsStyle = dataEl.dataset.variantOptionsStyle || "";
    const isCollectionCard =
      variantOptionsStyle === "none" ||
      variantOptionsStyle === "dropdown" ||
      form.closest(".c-product-card-atc--one-variant");

    const variantSelect = form.querySelector(".js-variant-select");
    const submitBtn = form.querySelector('input[type="submit"]');

    // Track current selections
    let selectedOptions = new Array(optionCount);

    // Track if user must pick a size
    let userMustPickSize = false;

    function findVariantBySelections(selections) {
      return (
        variantData.find(
          (v) => JSON.stringify(v.options) === JSON.stringify(selections),
        ) || null
      );
    }

    // Find a variant matching selected options, ignoring null values
    // Used when user hasn't selected all options yet (e.g., no size chosen)
    function findPartialVariantMatch(selections) {
      return variantData.find((variant) => {
        return selections.every((value, index) => {
          return value === null || variant.options[index] === value;
        });
      });
    }

    function applyAvailability() {
      // Find the currently matched variant (exact match)
      const matched = findVariantBySelections(selectedOptions);

      // Also find a partial match for gallery/price display when not all options selected
      const partialMatch = matched || findPartialVariantMatch(selectedOptions);

      // Loop each option index (e.g. color, size, pack)
      for (let i = 0; i < optionCount; i++) {
        // Gather which values should be enabled by looking at variantSelect options
        const enabled = new Set();

        Array.from(variantSelect.options).forEach((opt) => {
          const variant = variantData.find((v) => v.id == opt.value);
          if (!variant || !variant.available) return;

          // For collection cards, don't check compatibility with other options
          // Just check if this specific option value is available in any variant
          if (isCollectionCard) {
            if (variant.options[i]) {
              enabled.add(variant.options[i]);
            }
          } else {
            // Original logic: check compatibility with selected options
            let compatible = true;
            for (let j = 0; j < optionCount; j++) {
              if (j === i) continue; // skip the option we're checking
              if (
                selectedOptions[j] &&
                variant.options[j] !== selectedOptions[j]
              ) {
                compatible = false;
                break;
              }
            }

            if (compatible) {
              enabled.add(variant.options[i]);
            }
          }
        });

        // Now update swatches for this option
        form.querySelectorAll(`[data-option-index="${i}"]`).forEach((el) => {
          const val = el.getAttribute("data-option-value");
          const isEnabled = enabled.has(val);
          el.classList.toggle("is-disabled", !isEnabled);
          el.setAttribute("aria-disabled", String(!isEnabled));
        });

        // Update dropdowns
        const select = form.querySelector(`select[data-option-index="${i}"]`);
        if (select) {
          Array.from(select.options).forEach((opt) => {
            opt.disabled = !enabled.has(opt.value);
          });
        }
      }

      // Enable/disable add to cart
      const hasPickedSize = !userMustPickSize;
      const canAdd = matched && matched.available && hasPickedSize;
      if (submitBtn) {
        if (matched && !matched.available) {
          // Out of stock - hide button so Klaviyo button shows
          submitBtn.style.display = "none";
        } else if (!canAdd) {
          // No selection made yet - show disabled button
          submitBtn.style.display = "";
          submitBtn.disabled = true;
          submitBtn.value =
            window.Shopify.themeStrings?.makeASelection || "Select a size";
        } else {
          // In stock and ready to add
          submitBtn.style.display = "";
          submitBtn.disabled = false;
          submitBtn.value =
            window.Shopify.themeStrings?.addToCart || "Add to cart";
        }
      }

      // Update sold-out badge
      const soldOutBadge = document.querySelector(".js-sold-out-badge");
      if (soldOutBadge) {
        if (matched && !matched.available) {
          soldOutBadge.style.display = "";
        } else {
          soldOutBadge.style.display = "none";
        }
      }

      // Keep hidden variant <select> in sync
      if (variantSelect) {
        Array.from(variantSelect.options).forEach((opt) => {
          opt.selected = matched && opt.value == matched.id;
        });

        // Trigger change event for Klaviyo and other integrations
        variantSelect.dispatchEvent(new Event("change", { bubbles: true }));

        // Refresh Klaviyo back-in-stock button if available
        if (
          window.klaviyo &&
          typeof window.klaviyo.refreshBackInStock === "function"
        ) {
          window.klaviyo.refreshBackInStock();
        }

        // Fire custom event for gallery/price updates using partialMatch
        // This ensures gallery shows correct image even when not all options selected
        if (partialMatch) {
          const selectedOption = Array.from(variantSelect.options).find(
            (opt) => opt.value == partialMatch.id,
          );
          if (selectedOption) {
            const imageId = selectedOption.getAttribute("data-image-id");
            const variantId = selectedOption.value;

            const formatMoney = (
              amount,
              currency = window.Shopify?.currency?.active || "USD",
            ) => {
              // Use Shopify's money format if available
              const moneyFormat =
                window.Shopify?.money_with_currency_format ||
                `${{ amount }} ${currency}`;
              const amountInDollars = (amount / 100).toFixed(2);
              return moneyFormat.replace("{{amount}}", amountInDollars);
            };

            const event = new CustomEvent("variant:imageChange", {
              detail: {
                imageId,
                variantId,
                priceFormatted: formatMoney(partialMatch.price),
                compareAtPriceFormatted:
                  partialMatch.compare_at_price &&
                  partialMatch.compare_at_price > partialMatch.price
                    ? formatMoney(partialMatch.compare_at_price)
                    : null,
                productId: productId,
              },
            });
            document.dispatchEvent(event);
          }
        }
      }
    }

    function updateSelectedOption(index, value) {
      selectedOptions[index] = value;

      // If the user picks the size option, they can now add to cart
      if (index === sizeIndex) {
        userMustPickSize = false;
      }

      // Update UI
      form.querySelectorAll(`[data-option-index="${index}"]`).forEach((el) => {
        el.classList.toggle(
          "is-active",
          el.getAttribute("data-option-value") === value,
        );
      });

      // Update visible label for color
      const selectedColorLabel = form.querySelector("#selected-color");
      const clickedEl = Array.from(
        form.querySelectorAll(`[data-option-index="${index}"]`),
      ).find((el) => el.getAttribute("data-option-value") === value);

      const colorOptionName =
        window.Shopify.themeStrings.colorOption?.toLowerCase() || "color";

      if (clickedEl?.dataset.optionName?.toLowerCase() === colorOptionName) {
        selectedColorLabel.textContent = value;
      }

      // Update URL
      const matched = findVariantBySelections(selectedOptions);
      if (matched) {
        const url = new URL(window.location);
        url.searchParams.set("variant", matched.id);
        window.history.replaceState({}, "", url);
      }

      applyAvailability();
    }

    // ---- Initialize ----
    const initialVariant =
      variantData.find((v) => v.id === initialVariantId) ||
      variantData.find((v) => v.available) ||
      variantData[0];

    // Preselect ONLY color (option index 0). Leave size (index 1) undefined.
    selectedOptions = [...initialVariant.options];

    // UNSELECT size (only check for "Size", not "pack")
    const sizeIndex = initialVariant.options.findIndex((opt, idx) => {
      const el = form.querySelector(`[data-option-index="${idx}"]`);
      const name = el?.dataset.optionName?.toLowerCase() || "";
      return name === "size";
    });

    // If size exists, disable add to cart so user must make selection
    if (sizeIndex !== -1 && !isReinit) {
      userMustPickSize = true; // Require user to pick size
      selectedOptions[sizeIndex] = null; // Clear size so it doesn't affect color availability
      // alert("you gotta pick a size");
    }
    console.log({ selectedOptions });
    // Set initial active states
    selectedOptions.forEach((val, i) => {
      form.querySelectorAll(`[data-option-index="${i}"]`).forEach((el) => {
        // Skip toggling is-active for sizeIndex
        if (i === sizeIndex && userMustPickSize) return;

        el.classList.toggle(
          "is-active",
          el.getAttribute("data-option-value") === val,
        );
      });

      const select = form.querySelector(`select[data-option-index="${i}"]`);
      if (select) select.value = val;
    });

    applyAvailability();

    // Event bindings
    form
      .querySelectorAll("[data-option-index][data-option-value]")
      .forEach((el) => {
        el.addEventListener("click", () => {
          const index = parseInt(el.getAttribute("data-option-index"), 10);
          const value = el.getAttribute("data-option-value");
          updateSelectedOption(index, value);
        });
      });

    // Hover-to-preview for collection cards
    if (isCollectionCard) {
      let revertTimeout = null;

      // Find all option containers (color swatches, pack/size buttons)
      const swatchContainers = [
        ...form.querySelectorAll(".c-color-swatches-container"),
        ...form.querySelectorAll(".c-product-option--swatches"),
        ...form.querySelectorAll(".c-product-option--pack"),
        ...form.querySelectorAll(".c-product-option--size"),
        ...form.querySelectorAll(".c-product-option--buttons"),
        ...form.querySelectorAll(".c-size-buttons"),
      ];

      // Set up mouseleave for each option container
      swatchContainers.forEach((swatchContainer) => {
        if (!swatchContainer) return;

        // Track when entering/leaving the entire swatch area
        swatchContainer.addEventListener("mouseenter", () => {
          if (revertTimeout) {
            clearTimeout(revertTimeout);
            revertTimeout = null;
          }
        });

        swatchContainer.addEventListener("mouseleave", () => {
          // Revert to selected variant after leaving swatch area
          revertTimeout = setTimeout(() => {
            const matched = findVariantBySelections(selectedOptions);
            const partialMatch =
              matched || findPartialVariantMatch(selectedOptions);

            // Restore is-active state to the actually selected options
            selectedOptions.forEach((val, idx) => {
              form
                .querySelectorAll(`[data-option-index="${idx}"]`)
                .forEach((el) => {
                  el.classList.toggle(
                    "is-active",
                    el.getAttribute("data-option-value") === val,
                  );
                });
            });

            if (partialMatch && variantSelect) {
              const option = Array.from(variantSelect.options).find(
                (opt) => opt.value == partialMatch.id,
              );

              if (option) {
                const imageId = option.getAttribute("data-image-id");

                const formatMoney = (
                  amount,
                  currency = window.Shopify?.currency?.active || "USD",
                ) => {
                  const moneyFormat =
                    window.Shopify?.money_with_currency_format ||
                    `${{ amount }} ${currency}`;
                  const amountInDollars = (amount / 100).toFixed(2);
                  return moneyFormat.replace("{{amount}}", amountInDollars);
                };

                const event = new CustomEvent("variant:imageChange", {
                  detail: {
                    imageId,
                    variantId: partialMatch.id,
                    priceFormatted: formatMoney(partialMatch.price),
                    compareAtPriceFormatted:
                      partialMatch.compare_at_price &&
                      partialMatch.compare_at_price > partialMatch.price
                        ? formatMoney(partialMatch.compare_at_price)
                        : null,
                    productId: productId,
                  },
                });
                document.dispatchEvent(event);
              }
            }
          }, 100);
        });
      });

      // Hover on individual swatches/buttons to preview
      form
        .querySelectorAll("[data-option-index][data-option-value]")
        .forEach((swatch) => {
          swatch.addEventListener("mouseenter", () => {
            const index = parseInt(
              swatch.getAttribute("data-option-index"),
              10,
            );
            const value = swatch.getAttribute("data-option-value");

            // Temporarily add is-active to hovered element
            // Remove is-active from all siblings in the same option index
            form
              .querySelectorAll(`[data-option-index="${index}"]`)
              .forEach((el) => {
                el.classList.remove("is-active");
              });
            swatch.classList.add("is-active");

            // Create temporary selections to find the hovered variant
            const tempSelections = [...selectedOptions];
            tempSelections[index] = value;
            const hoveredVariant = findVariantBySelections(tempSelections);

            if (hoveredVariant && variantSelect) {
              const option = Array.from(variantSelect.options).find(
                (opt) => opt.value == hoveredVariant.id,
              );

              if (option) {
                const imageId = option.getAttribute("data-image-id");

                const formatMoney = (
                  amount,
                  currency = window.Shopify?.currency?.active || "USD",
                ) => {
                  const moneyFormat =
                    window.Shopify?.money_with_currency_format ||
                    `${{ amount }} ${currency}`;
                  const amountInDollars = (amount / 100).toFixed(2);
                  return moneyFormat.replace("{{amount}}", amountInDollars);
                };

                const event = new CustomEvent("variant:imageChange", {
                  detail: {
                    imageId,
                    variantId: hoveredVariant.id,
                    priceFormatted: formatMoney(hoveredVariant.price),
                    compareAtPriceFormatted:
                      hoveredVariant.compare_at_price &&
                      hoveredVariant.compare_at_price > hoveredVariant.price
                        ? formatMoney(hoveredVariant.compare_at_price)
                        : null,
                    productId: productId,
                  },
                });
                document.dispatchEvent(event);
              }
            }
          });
        });
    }

    form.querySelectorAll("select[data-option-index]").forEach((select) => {
      select.addEventListener("change", () => {
        const index = parseInt(select.getAttribute("data-option-index"), 10);
        updateSelectedOption(index, select.value);
      });
    });

    // form.querySelectorAll(".js-qty-btn").forEach((btn) => {
    //   btn.addEventListener("click", () => {
    //     const input = form.querySelector('input[name="quantity"]');
    //     const change = parseInt(btn.getAttribute("data-change"), 10);
    //     const newQty = Math.max(1, parseInt(input.value || "1", 10) + change);
    //     input.value = newQty;
    //   });
    // });

    // Mark this form as initialized
    form.dataset.formInitialized = "true";
  });
}
// Initialize on DOM ready
document.addEventListener("DOMContentLoaded", () => {
  initProductForm();
});

// Re-initialize after AJAX collection update
if (!productFormInitialized) {
  productFormInitialized = true;

  document.addEventListener("collection:updated", () => {
    initProductForm();
  });

  // Re-initialize after AJAX cart refresh
  document.addEventListener("cart:refreshed", () => {
    initProductForm(true); // or any function that needs new DOM bindings
  });
}

export { initProductForm };
